import useUpdateEffect from './useUpdateEffect';
var useDebounce = function useDebounce(fn, ms, args) {
  if (ms === void 0) {
    ms = 0;
  }
  if (args === void 0) {
    args = [];
  }
  useUpdateEffect(function () {
    var handle = setTimeout(fn.bind(null, args), ms);
    return function () {
      // if args change then clear timeout
      clearTimeout(handle);
    };
  }, args);
};
export default useDebounce;